import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tooltip,
  Tr,
  useToast,
} from '@chakra-ui/react'
import Header from '../../../components/Header'
import { HeadingPages } from '../../../components/HeadingPages'
import { ErrorBoundary } from 'react-error-boundary'
import { QueryErrorResetBoundary, useQuery } from 'react-query'
import { Loader } from '../../../components/ComponentLoader/Loader'
import { Suspense } from 'react'
import { api } from '../../../services/api'
import { format } from 'date-fns'

export function DescontoProduto() {
  const toast = useToast()

  const { data } = useQuery(
    ['chamados'],
    async () => {
      const response = await api.get('/pedido/listar-informacoes-desconto')

      const data = response.data

      return data
    },
    {
      onError: () => {
        toast({
          title: 'Erro ao carregar os dados',
          status: 'error',
          duration: 3000,
          isClosable: true,
        })
      },
    }
  )

  console.log(data)

  return (
    <>
      <HeadingPages name="Lista de desconto produto" />

      <Suspense fallback={<Loader />}>
        <TableContainer>
          <Table
            variant="striped"
            colorScheme="facebook"
            width="100%"
            maxWidth={1120}
            marginX="auto"
            marginTop="4"
            size="sm"
          >
            <Thead>
              <Tr>
                <Th textAlign="center">Usuário desconto</Th>
                <Th textAlign="center">Data solicitação</Th>
                <Th textAlign="center">Código Produto</Th>
                <Th textAlign="center">Peças danificadas</Th>
                <Th textAlign="center">Observação</Th>
              </Tr>
            </Thead>

            <QueryErrorResetBoundary>
              {({ reset }) => (
                <ErrorBoundary
                  onReset={reset}
                  fallbackRender={({ resetErrorBoundary }) => (
                    <div>
                      Erro ao carregar os dados{' '}
                      <button onClick={() => resetErrorBoundary()}>
                        Tentar novamente
                      </button>
                    </div>
                  )}
                >
                  <Tbody>
                    {data?.map((item) => (
                      <Tr>
                        <Td textAlign="center">{item.nome_usuario_desconto}</Td>
                        <Td textAlign="center">
                          {item.data_solicitacao &&
                            format(
                              new Date(item.data_solicitacao),
                              'dd/MM/yyyy'
                            )}
                        </Td>
                        <Td textAlign="center">{item.codigo_produto}</Td>
                        <Td textAlign="center">{item.pecas_danificadas}</Td>
                        <Tooltip
                          label={item?.observacao}
                          aria-label="A tooltip"
                        >
                          <Td textAlign="center">
                            {item.observacao &&
                              item.observacao.substring(0, 10) + '...'}
                          </Td>
                        </Tooltip>
                      </Tr>
                    ))}
                  </Tbody>
                </ErrorBoundary>
              )}
            </QueryErrorResetBoundary>
          </Table>
        </TableContainer>
      </Suspense>
    </>
  )
}
